import type { LiabilityFormLayout } from "../types";

export const liabilityAmountLayout = (): LiabilityFormLayout => {
  return {
    render: 'amount'
  }
}
